import script from "./MainNavigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainNavigation.vue?vue&type=script&lang=ts&setup=true"

import "./MainNavigation.vue?vue&type=style&index=0&id=e788e67e&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e788e67e"]])

export default __exports__